var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "tableBox", staticClass: "table-box" },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.standardDangerData,
            "span-method": _vm.dangerSpanMethod,
            border: "",
            height: "360",
            "header-cell-class-name": "risk-table-header",
            "cell-class-name": "cell-class"
          }
        },
        [
          _c("el-table-column", {
            attrs: { label: "#", prop: "index", width: "50", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "insecurityText", label: "典型事件", width: "300" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        staticClass: "insecurity",
                        on: {
                          click: function($event) {
                            return _vm.onInsecurityClick(scope.row)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.insecurityText) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "dangerDesc", label: "危险源描述", width: "400" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", { staticClass: "danger-desc-box" }, [
                      _c(
                        "div",
                        {
                          staticClass: "danger-desc",
                          on: {
                            click: function($event) {
                              return _vm.onDangerDescClick(scope.row)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(scope.row.dangerDesc) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "detail-link" },
                        [
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: "点击查看危险源详情",
                                placement: "right-start"
                              }
                            },
                            [
                              _c(
                                "el-link",
                                {
                                  attrs: {
                                    type: "primary",
                                    underline: false,
                                    target: "_blank",
                                    href: _vm.$util.buildSmsActivityDetailUrl(
                                      scope.row.activityId
                                    )
                                  }
                                },
                                [_c("i", { staticClass: "el-icon-view" })]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "ecDept", label: "屏障分类", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "riskLevel", label: "风险等级", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      {
                        class: _vm.$util.getRiskLevelColor(
                          scope.row.riskLevelColor
                        )
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.riskLevel) +
                            "\n        "
                        )
                      ]
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "barrierDesc",
              label: "屏障",
              width: "400",
              "show-overflow-tooltip": true
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-de5cde1e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de5cde1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/risk/CoreRiskDanger.vue
// module id = null
// module chunks = 